"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ic_arrow_drop_down = exports.ic_arrow_drop_down = { "viewBox": "0 0 24 24", "children": [{ "name": "path", "attribs": { "d": "M7 10l5 5 5-5z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/md/ic_arrow_drop_down.js
// module id = 358
// module chunks = 1